// import axios from 'axios';

export default {

    //Permet de récuperer le media/media/show/{id}
    get(mediaId) {
        // return axios.get(process.env.VUE_APP_API_URI + '/api/media/show/' + mediaId);
        return process.env.VUE_APP_API_URI + '/api/media/show/' + mediaId;
    },

    //Permet de récuperer le dico
    getDico() {
        return process.env.VUE_APP_API_URI + '/api/media/dico/show';
    }
}
